// Riches (Pluto): every star has a base value of at least so much.
import { ALIGNMENT_NUMBERS as N } from '../constants';
import type { AlignmentDef } from '../types';

export const riches: AlignmentDef = {
  id: 'riches',
  planet: 'pluto',
  name: 'Riches',
  text: () => `Every star has a base value of at least ${N.richesBase}.`,
  baseSet: (star) => (star.base < N.richesBase ? N.richesBase : undefined),
};
